export const CURRENCY_CREATE_REQUEST = 'CURRENCY_CREATE_REQUEST'
export const CURRENCY_CREATE_SUCCESS = 'CURRENCY_CREATE_SUCCESS'
export const CURRENCY_CREATE_FAIL = 'CURRENCY_CREATE_FAIL'